import React, { useState, useEffect } from "react";
import {
  Label,
  Container,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import apiClient from "../../axiosInstance";
import showAlert from "../../components/Common/ShowAlert";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const RegistrationFees = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Registration Fees", link: "#" },
  ]);

  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    purpose: "",
    fee: "",
  });

  const fetchFees = async () => {
    try {
      const result = await apiClient.get("/fees/registration-fees");
      setData(result.data.response);
    } catch (err) {
      console.error("Error fetching registration fees:", err);
    }
  };

  useEffect(() => {
    fetchFees();
  }, []);

  const toggleModal = () => {
    setFormData({
      id: null,
      purpose: "",
      fee: "",
    });
    setModalOpen(!modalOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveFee = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (formData.id) {
        response = await apiClient.put(
          `/fees/registration-fees/${formData.id}`,
          formData
        );
      } else {
        response = await apiClient.post("/fees/registration-fees", formData);
      }
      await showAlert({
        title: "Registration Fee",
        text: response.data.message,
        icon: response.data.status,
        goBack: false,
        timer: 5000,
      });
      if (response.data.status === "success") {
        setModalOpen(false);
        fetchFees();
      }
    } catch (err) {
      console.error("Error saving registration fee:", err);
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "purpose",
      header: "Purpose",
    },
    {
      accessorKey: "fee",
      header: "Fee",
      cell: ({ row }) => <span>{row.original.fee}</span>,
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => (
        <span
          className={`badge bg-${
            row.original.status === "Active"
              ? "success"
              : row.original.status === "Inactive"
              ? "secondary"
              : "danger"
          }`}
        >
          {row.original.status}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => {
            setFormData({
              id: row.original.id,
              purpose: row.original.purpose,
              fee: row.original.fee,
            });
            setModalOpen(true);
          }}
        >
          <i className="ri-file-edit-line"></i>
        </button>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs
              title="Registration Fees"
              breadcrumbItems={breadcrumbItems}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-12 text-end mb-2">
                    <button className="btn btn-primary" onClick={toggleModal}>
                      Create Registration Fee
                    </button>
                  </div>
                </div>
                <TanstackTable data={data} columns={columns} />
              </CardBody>
            </Card>
          </div>
        </div>
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          centered={true}
          backdrop="static"
        >
          <form onSubmit={handleSaveFee}>
            <ModalHeader toggle={toggleModal}>
              {formData.id ? "Update" : "Create"} Registration Fee
            </ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-12 mb-3">
                  <Label className="form-label">Purpose</Label>
                  <input
                    type="text"
                    name="purpose"
                    className="form-control"
                    placeholder="Enter Purpose"
                    value={formData.purpose}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-12 mb-3">
                  <Label className="form-label">Fee</Label>
                  <input
                    type="number"
                    name="fee"
                    className="form-control"
                    placeholder="Enter Fee"
                    value={formData.fee}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                className="btn btn-secondary"
                onClick={toggleModal}
                type="button"
              >
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                Save
              </button>
            </ModalFooter>
          </form>
        </Modal>
      </Container>
    </div>
  );
};

export default RegistrationFees;
